export default __webpack_public_path__ + "static/media/69_desktop.54660a69.jpg";